export default __webpack_public_path__ + "src/components/pages/login/customers/aa3301b39838b790dcd887743804ca37.png";